module.exports = __webpack_public_path__ + "static/build-b6ba39db75be513f2c670ca64e0db764.png";